import { createFileRoute, Link } from '@tanstack/react-router'
import { Section, SectionHeader } from '@/components/ui/section'
import { Button } from '@/components/ui/button'
import { BarChart3, History, Settings, Play } from 'lucide-react'

export const Route = createFileRoute('/backtesting')({
  component: BacktestingComponent,
})

function BacktestingComponent() {
  return (
    <div className="min-h-screen">
      <section className="gradient-hero py-20">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 badge badge-primary mb-6">
              <History className="h-4 w-4" />
              <span>Backtesting Engine</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Validate Strategies with <span className="text-gradient">Historical Data</span>
            </h1>
            <p className="text-xl text-muted-foreground mb-8">
              Run simulations across years of tick-level futures data to verify your edge before risking capital.
            </p>
            <Link to="/dashboard/backtests/new">
              <Button size="lg" className="text-lg px-8 py-3">
                <Play className="mr-2 h-5 w-5" />
                New Simulation
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Section>
        <SectionHeader title="Capabilities" description="Institutional-grade testing environment" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="card p-6">
            <BarChart3 className="h-8 w-8 text-primary mb-4" />
            <h3 className="font-semibold mb-2">Deep Analytics</h3>
            <p className="text-sm text-muted-foreground">Sharpe ratio, max drawdown, win rate, and more.</p>
          </div>
          <div className="card p-6">
            <Settings className="h-8 w-8 text-primary mb-4" />
            <h3 className="font-semibold mb-2">Optimization</h3>
            <p className="text-sm text-muted-foreground">Parameter sweeping to find the optimal settings.</p>
          </div>
          <div className="card p-6">
            <History className="h-8 w-8 text-primary mb-4" />
            <h3 className="font-semibold mb-2">Tick Data</h3>
            <p className="text-sm text-muted-foreground">High-fidelity data for accurate simulation.</p>
          </div>
          <div className="card p-6">
            <Shield className="h-8 w-8 text-primary mb-4" />
            <h3 className="font-semibold mb-2">Walk-Forward</h3>
            <p className="text-sm text-muted-foreground">Avoid overfitting with walk-forward analysis.</p>
          </div>
        </div>
      </Section>
    </div>
  )
}

function Shield(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    </svg>
  )
}
